import React from 'react';
import { SelectProps } from '@mui/material';
import { SelectWithOptions } from './SelectWithOptions';
import { useContentFilterOptions } from '~/src/hooks/useContentFilterOptions';

export const PracticeArea = React.forwardRef((props: SelectProps, ref) => {
  const { data } = useContentFilterOptions();
  const practiceAreas = data?.practice_areas || [];

  return (
    <SelectWithOptions
      inputProps={{ 'data-testid': 'survey-practice-area' }}
      ref={ref}
      {...props}
      options={practiceAreas}
    />
  );
});
